<template>
  <div id="hwlist">
    <Table v-if="utype && utype == 'TEACHER'" height="400" :columns="teacherHwCols" :data="hwlistShow" :loading="spinShow"></Table>
    <Table v-if="utype && utype == 'STUDENT'" height="400" :columns="studentHwCols" :data="hwlistShow" :loading="spinShow"></Table>

    <Page style="float: right;margin: 5px" :current="pageInfo.current"
          :total="pageInfo.total" :page-size="pageInfo.size"
          @on-change="changePage"></Page>


    <Modal
      v-model="studentHwSubModelShow"
      title="学生作业提交"
      @on-ok="studentHwSub"
      @on-cancel="studentHwCancel">

      <Form ref="studentHw" :model="studentHw" :rules="studentHwRule">
        <FormItem prop="solution">
          <Input v-model="studentHw.solution" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="作业内容"/>
        </FormItem>
      </Form>
    </Modal>

    <Modal
      v-model="teacherHwSubModelShow"
      title="老师答案上传"
      @on-ok="teacherHwSub"
      @on-cancel="teacherHwCancel">

      <Form ref="teacherHw" :model="teacherHw" :rules="teacherHwRule">
        <FormItem prop="solution">
          <Input v-model="teacherHw.answer" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="作业内容"/>
        </FormItem>
      </Form>
    </Modal>
  </div>

</template>

<script>
import {mapState} from 'vuex'
import _ from 'lodash'
import expandRow from './sub-teacher-table-expand.vue';

export default {
  components: { expandRow },
  data () {
    return {
      statusMap: {0: '待学生提交', 1: '待老师打分', 2: '完成', 3: '暂无'},
      spinShow: false,
      studentHwSubModelShow: false,
      studentHw: {solution: ''},
      studentHwRule: {
        solution: [
          {required: true, type: 'string', message: '请输作业内容', trigger: 'blur'}
        ]
      },
      teacherHwSubModelShow: false,
      teacherHw: {answer: ''},
      teacherHwRule: {
        solution: [
          {required: true, type: 'string', message: '请输作业内容', trigger: 'blur'}
        ]
      },
      utype: 'STUDENT',
      pageInfo: {current: 1, size: 5},
      hwlist: [],
      hwlistShow: [],
      teacherHwCols: [
        {
          type: 'expand',
          width: 50,
          render: (h, params) => {
            return h(expandRow, {
              props: {
                row: params.row,
                score: this.score
              }
            })
          }
        },
        {
          title: '编号',
          key: 'hwid'
        }, {
          title: '课程',
          key: 'course'
        }, {
          title: '标题',
          key: 'title'
        }, {
          title: '内容',
          key: 'content'
        }, {
          title: '结束时间',
          render: (h, params) => {
            let d = new Date(params.row.endtime);
            return h('div', d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate());
          }
        }, {
          title: '老师',
          render: (h, params) => {
            return h('div', params.row.teacherInfo.name);
          }
        }, {
          title: '答案',
          key: 'answer'
        }, {
          title: '操作',
          key: 'action',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.popTeacherHwSub(params.row)
                  }
                }
              }, '上传答案')
            ]);
          }
        }
      ],
      studentHwCols: [
        {
          title: '编号',
          key: 'hwid'
        }, {
          title: '课程',
          key: 'course'
        }, {
          title: '标题',
          key: 'title'
        }, {
          title: '内容',
          key: 'content'
        }, {
          title: '结束时间',
          render: (h, params) => {
            let d = new Date(params.row.endtime);
            return h('div', d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate());
          }
        }, {
          title: '老师',
          render: (h, params) => {
            return h('div', params.row.teacherInfo.name);
          }
        }, {
          title: '状态',
          render: (h, params) => {
            return h('div', this.statusMap[_.get(params.row, 'process.status', 3)]);
          }
        }, {
          title: '评分',
          render: (h, params) => {
            return h('div', _.get(params.row, 'process.score', '暂无'));
          }
        }, {
          title: '老师答案',
          key: 'answer'
        }, {
          title: '我的答案',
          render: (h, params) => {
            return h('div', _.get(params.row, 'process.solution', '暂无'));
          }
        }, {
          title: '操作',
          key: 'action',
          render: (h, params) => {
            if (_.get(params.row, 'process.status', 3) === 0) {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.popStudentHwSub(params.row)
                    }
                  }
                }, '提交作业')
              ])
            }
          }
        }
      ]
    }
  },
  methods: {
    // 弹出提交作业页面
    popStudentHwSub: function (hw) {
      let vueThis = this
      vueThis.studentHw.hwid = hw.hwid
      vueThis.studentHwSubModelShow = true
    },
    // 学生作业提交
    studentHwSub: function () {
      let vueThis = this
      vueThis.spinShow = true;
      let params = [vueThis.studentHw.hwid + '', vueThis.studentHw.solution]
      vueThis.$store.dispatch('callNew', {funcName: 'studentPostHW', params: params}).then((ret) => {
        vueThis.showSuccess('学生作业提交成功！');
        vueThis.getHwlist();
        vueThis.spinShow = false;
      }, (error) => {
        vueThis.spinShow = false;
        vueThis.showErr('学生作业提交失败' + error);
      });
    },
    // 学生作业取消
    studentHwCancel: function () {
      let vueThis = this
      vueThis.studentHwSubModelShow = false
    },
    // 弹出老师上传答案页面
    popTeacherHwSub: function (hw) {
      let vueThis = this
      vueThis.teacherHw.hwid = hw.hwid
      vueThis.teacherHwSubModelShow = true
    },
    // 老师上传答案
    teacherHwSub: function () {
      let vueThis = this
      vueThis.spinShow = true;
      let params = [vueThis.teacherHw.hwid + '', vueThis.teacherHw.answer]
      vueThis.$store.dispatch('callNew', {funcName: 'teacherPostAnswer', params: params}).then((ret) => {
        vueThis.showSuccess('老师上传答案成功！');
        vueThis.getHwlist();
        vueThis.spinShow = false;
      }, (error) => {
        vueThis.spinShow = false;
        vueThis.showErr('老师上传答案失败' + error);
      });
    },
    // 老师答案取消上传
    teacherHwCancel: function () {
      let vueThis = this
      vueThis.teacherHwSubModelShow = false
    },
    // 老师给学生评分
    score: function (s, point) {
      console.log('评分', s, point)
      let vueThis = this
      vueThis.spinShow = true;
      let params = [s.homework.hwid, s.address, point]
      vueThis.$store.dispatch('callNew', {funcName: 'judgeHomework', params: params}).then((ret) => {
        vueThis.showSuccess('打分成功！');
        vueThis.getHwlist();
        vueThis.spinShow = false;
      }, (error) => {
        vueThis.spinShow = false;
        vueThis.showErr('打分失败' + error);
      });
    },
    // 获取作业
    getHwlist: function () {
      var vueThis = this
      vueThis.spinShow = true;
      vueThis.$store.dispatch('simulateCallNew', {funcName: 'getMyHWList'}).then((ret) => {
        let data = JSON.parse(ret);
        console.log('获取作业', data);
        vueThis.utype = data.utype;
        vueThis.hwlist = data.data;
        vueThis.spinShow = false;
        vueThis.changePage(1);
      }, (error) => {
        vueThis.spinShow = false;
        vueThis.showErr('获取作业列表' + error);
      });
    },
    // 修改页码
    changePage (pageNum) {
      let vueThis = this;
      vueThis.spinShow = true;
      vueThis.hwlistShow = [];
      let p = vueThis.pageInfo;
      p.current = !pageNum ? 1 : pageNum;
      let maxPage = Math.ceil(p.total / p.size);
      p.current = _.min([p.current, maxPage])
      p.total = _.get(vueThis.hwlist, 'length', 0);

      let start = (p.current - 1) * p.size;
      let end = _.min([p.current * p.size, p.total]);

      vueThis.hwlistShow = _.slice(vueThis.hwlist, start, end);
      vueThis.spinShow = false;
    }
  },
  created () {
    this.getHwlist()
  },
  computed: mapState([
    'user'
  ])
}
</script>

<style>
  #hwlist{
  }
</style>



// WEBPACK FOOTER //
// src/components/base-homework-mine.vue